import { Box, Divider, VStack } from "@chakra-ui/react";
import ApiKey from "./apiKey";
import SandboxToggle from "./sandbox";
import Webhook from "./webhook";

export default function Settings() {
  return (
    <Box>
      <VStack p={10} align="stretch" gap={10}>
        <SandboxToggle />
        <Divider bg="gray.400" height="1px" />
        <ApiKey />
        <Divider bg="gray.400" height="1px" />
        <Webhook />
      </VStack>
    </Box>
  );
}
